module.exports = __webpack_public_path__ + "img/cgh.bcf91af3.jpg";